var _circle, _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovedCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#219653"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0518 15.3852L7.8918 13.2252C7.61028 12.9437 7.61028 12.4887 7.8918 12.2071C8.17332 11.9256 8.62836 11.9256 8.90988 12.2071L10.5198 13.8171L15.0544 8.64819C15.3136 8.34579 15.7679 8.31123 16.0688 8.56971C16.3712 8.82891 16.4065 9.28251 16.1473 9.58419L11.1073 15.3442C10.977 15.4968 10.7884 15.5875 10.5882 15.5955C10.37 15.5962 10.1864 15.5206 10.0518 15.3852Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 10,
    height: 8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0518 15.3852L7.8918 13.2252C7.61028 12.9437 7.61028 12.4887 7.8918 12.2071C8.17332 11.9256 8.62836 11.9256 8.90988 12.2071L10.5198 13.8171L15.0544 8.64819C15.3136 8.34579 15.7679 8.31123 16.0688 8.56971C16.3712 8.82891 16.4065 9.28251 16.1473 9.58419L11.1073 15.3442C10.977 15.4968 10.7884 15.5875 10.5882 15.5955C10.37 15.5962 10.1864 15.5206 10.0518 15.3852Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedCheck);
export default __webpack_public_path__ + "static/media/approved-check.b6b25e96.svg";
export { ForwardRef as ReactComponent };